export function ProductCardSkeleton() {
  return (
    <div className="bg-card rounded-[20px] overflow-hidden shadow-luxe">
      <div className="relative aspect-[4/5] overflow-hidden bg-secondary">
        <div className="absolute inset-0 shimmer" />
      </div>
      <div className="p-5 space-y-3">
        <div className="h-2.5 w-20 rounded-full bg-secondary relative overflow-hidden">
          <div className="absolute inset-0 shimmer" />
        </div>
        <div className="h-5 w-3/4 rounded-md bg-secondary relative overflow-hidden">
          <div className="absolute inset-0 shimmer" />
        </div>
        <div className="h-3 w-24 rounded-full bg-secondary relative overflow-hidden">
          <div className="absolute inset-0 shimmer" />
        </div>
        <div className="h-5 w-16 rounded-md bg-secondary relative overflow-hidden">
          <div className="absolute inset-0 shimmer" />
        </div>
      </div>
    </div>
  );
}